var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlinehqPictureStack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.33 9.7a.87.87 0 0 0-1.7 0L11 13.17a.27.27 0 0 1-.2.14.24.24 0 0 1-.22-.09l-1.1-1.31a1.16 1.16 0 0 0-2 .15L5.07 16.2a.5.5 0 0 0 .43.8h11a.5.5 0 0 0 .46-.69Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.5 18.5V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v16.5a2 2 0 0 0 2 2h16.5a2 2 0 0 0 2-2M2 2.5a.5.5 0 0 1 .5-.5H18a.5.5 0 0 1 .5.5V18a.5.5 0 0 1-.5.5H2.5A.5.5 0 0 1 2 18Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 6a1 1 0 0 0-1 1v14.5a.5.5 0 0 1-.5.5H7a1 1 0 0 0 0 2h15a2 2 0 0 0 2-2V7a1 1 0 0 0-1-1"
}))));
export default SvgStreamlinehqPictureStack;